export default __webpack_public_path__ + "static/media/screen_wizard_3.cce35259.png";